import React, { useEffect, useState } from "react";
import { ButtonSingle } from "../../../../widget/common/form/Button";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Center from "../../../../widget/common/ui/Center";
import { TextBlock } from "../../../../widget/common/ui/Text";
import Div from "../../../../widget/common/ui/Div";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { DefaultBranch } from "../../../../model/settings/SettingsChangeDefaultBranchModel";
import Loader from "../../../../widget/common/ui/Loader";
import { textCase } from "../../../../service/ui/UI";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import AppConfigService from "../../../../service/app_config/AppConfigService";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { SettingsChangeDefaultBranchContextImport } from "../../../../provider/settings/change_default_branch/SettingsChangeDefaultBranchContextProvider";

export const SettingsChangeDefaultBranchInfo = (props: {
  type?: number;
  branchDefault: DefaultBranch | undefined;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const branchDefault: DefaultBranch | undefined =
    props.branchDefault ?? undefined;

  const [companyLogo, setCompanyLogo] = useState<string>("");
  const [companyName, setCompanyName] = useState<string>("");
  const [buildingNoName, setBuildingNoName] = useState<string>("");
  const [streetAreaName, setStreetAreaName] = useState<string>("");
  const [cityStateCountryName, setCityStateCountryName] = useState<string>("");

  const setupLogo = () => {
    setCompanyLogo(AppConfigService.get("company_logo"));
    setCompanyName(AppConfigService.get("company_name"));

    if (branchDefault !== undefined) {
      let buildingNoName: Array<string> = [
        branchDefault?.building_number!,
        branchDefault?.building_name!,
      ];

      let streetAreaName: Array<string> = [
        branchDefault?.street_name!,
        branchDefault?.area_name!,
      ];

      let cityStateCountryName: Array<string> = [
        branchDefault?.city_name!,
        branchDefault?.state_name!,
        branchDefault?.country_name!,
      ];

      buildingNoName = buildingNoName.filter((el) => el);
      streetAreaName = streetAreaName.filter((el) => el);
      cityStateCountryName = cityStateCountryName.filter((el) => el);

      setBuildingNoName(buildingNoName.join(", "));
      setStreetAreaName(streetAreaName.join(", "));
      setCityStateCountryName(cityStateCountryName.join(", "));
    }
  };

  useEffect(() => {
    setupLogo();
    // eslint-disable-next-line
  }, [branchDefault]);

  return (
    <Div className="pt-5 h-100">
      {branchDefault === undefined ? (
        <Center className="h-100">{Loader.normal()}</Center>
      ) : (
        <>
          <Center>
            <LogoRound
              url={companyLogo}
              size={type === 1 ? 73 : type === 2 ? 130 : 160}
              name={companyName}
            />
          </Center>
          <SpacingHeight value={type === 1 ? 14 : 18} />
          <TextBlock
            fontName="medium"
            fontSize="18"
            textColor="primary"
            center={true}
          >
            {textCase(branchDefault?.title!)}
          </TextBlock>
          <SpacingHeight value={type === 1 ? 39 : type === 2 ? 28 : 26} />
          <TextBlock
            fontName="book"
            fontSize="13_14"
            textColor="theme-sublabel"
            center={true}
          >
            {UtilityHelper.isNotEmpty(buildingNoName) && (
              <>
                {textCase(buildingNoName)}
                <br />
              </>
            )}

            {UtilityHelper.isNotEmpty(streetAreaName) && (
              <>
                {textCase(streetAreaName)}
                <br />
              </>
            )}

            {UtilityHelper.isNotEmpty(cityStateCountryName) && (
              <>
                {textCase(cityStateCountryName)}
                <br />
              </>
            )}
          </TextBlock>
        </>
      )}
    </Div>
  );
};

export const SettingsChangeDefaultBranchButton = (props: { type?: number }) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  const { onClickChange, branchDefaultInfo } =
    SettingsChangeDefaultBranchContextImport();

  return branchDefaultInfo !== undefined ? (
    <ButtonSingle
      width={type === 1 ? undefined : 350}
      handleClick={() => onClickChange()}
    >
      {AppTranslation.text("change")}
    </ButtonSingle>
  ) : (
    <></>
  );
};
